/** HTTP 局域网缺少 randomUUID 时，仍使用浏览器密码学随机源生成 UUID v4。 */
export function randomUuid(): `${string}-${string}-${string}-${string}-${string}` {
  if (typeof globalThis.crypto.randomUUID === 'function')
    return globalThis.crypto.randomUUID();
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
}
